// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3kezi","content":"RecentSearches_content__1njIP"};